import { isEmpty, isFunction } from "./type";

let eventList = {};
window._eventList = eventList;
/**
 * 添加多事件回调
 * @param {string} event
 * @param {string} key
 * @param {Function} cb
 */
export function addEvent(event, key, cb) {
  if (!(typeof event === "string" && event) || !(typeof key === "string" && key)) {
    console.error("addEvent can't add event! Params 'event' or 'key' is't String!");
    return;
  }
  if (!isFunction(cb)) {
    console.error("addEvent can't add event! Params 'cb' is't Function!");
    return;
  }
  if (isEmpty(eventList[event])) {
    eventList[event] = [];
    window.addEventListener(event, e => {
      eventList[event]?.forEach(obj => {
        if (e && e.key === obj.key) {
          obj.cb(e, obj.key);
        }
      });
    });
  }
  try {
    eventList[event].push({ key, cb });
  } catch (err) {
    console.error(err);
  }
}

/**
 * 移除多事件回调
 * @param {string} event
 * @param {string} key
 */
export function removeEvent(event, key) {
  if (!(typeof event === "string" && event) || !(typeof key === "string" && key)) {
    console.error("addEvent can't add event! Params 'event' or 'key' is't String!");
    return;
  }
  const index = eventList[event]?.findIndex(item => item.key === key);
  if (index !== -1) {
    try {
      let cb = eventList[event][index];
      if (cb) {
        window.removeEventListener(key, cb);
      }
      eventList[event].splice(index, 1);
    } catch (err) {
      console.error(err);
    }
  }
}

export function addScrollEvent(key, cb) {
  addEvent("scroll", key, cb);
}

export function removeScrollEvent(key) {
  removeEvent("scroll", key);
}
